export default __webpack_public_path__ + "checkbox 2x.svg";